import { useState } from 'react';
import { reviews } from '@/mocks/reviews';

export default function ReviewSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  const review = reviews[currentIndex];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-12">
          <span className="text-xs text-foreground-400 tracking-widest uppercase mb-2 block">网友评价</span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900">
            「 吃瓜群众真实反馈 」
          </h2>
        </div>

        <div className="relative">
          <div className="flex items-start gap-5 md:gap-6 mb-6">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-foreground-900 text-accent-400 text-xs font-semibold flex-shrink-0">
              <i className="ri-star-fill text-xs"></i>
              <span>{review.rating}</span>
            </div>
          </div>

          <blockquote className="mb-8">
            <p className="text-lg md:text-xl text-foreground-800 leading-relaxed font-heading">
              &ldquo;{review.content}&rdquo;
            </p>
          </blockquote>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img
                src={review.avatar}
                alt={review.userName}
                className="w-11 h-11 rounded-full object-cover"
                loading="lazy"
              />
              <div>
                <p className="text-sm font-semibold text-foreground-900">{review.userName}</p>
                <p className="text-xs text-foreground-400">{review.date}</p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <button
                onClick={goToPrev}
                className="w-9 h-9 flex items-center justify-center rounded-md border border-foreground-200 text-foreground-600 hover:bg-foreground-100 transition-colors duration-200"
                aria-label="上一条评价"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={goToNext}
                className="w-9 h-9 flex items-center justify-center rounded-md bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors duration-200"
                aria-label="下一条评价"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          <div className="flex items-center justify-center gap-1.5 mt-6">
            {reviews.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  idx === currentIndex ? 'bg-foreground-900 w-5' : 'bg-foreground-300'
                }`}
                aria-label={`第${idx + 1}条评价`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}